

import fetchData from './fetchData';
import getIdToken from './getIdToken';



const fetchTableData = async ({
    user, 
    searchParams, 
    setLoading, 
    apiUrl, 
    dataKey,
    rowsPerPage,
    setPaginatedlist, 
    setTotalCount,
    setPage,
    useOffset = false,
}) => {
    setLoading(true);
    try{
        if(!user) return;
        
        const allData = await fetchData({
            url: apiUrl,
        });
        const returnedData = allData?.[dataKey];

        const normalizedCreated = (item) => {
            const created = item.created?? item.Created?? item.creationTime;
            if(typeof created === 'number'){
                return new Date(created < 10000000000 ? created * 1000 : created);
            } else if (typeof created === 'string') {
                return new Date(created);
            }else if(created instanceof Date){
                return created;
            }else {
                return created?.toDate?.() || new Date();
            }
        };
        const formattedData = Array.isArray(returnedData)
            ? returnedData.map(data => {
                return {    
                    ...data,
                    creationTime: normalizedCreated(data),
                }})
            : returnedData != null
                ?[{    
                    ...returnedData,
                    creationTime: normalizedCreated(returnedData),
                }]
                :[]

        //if backend support offset or pagination, then receive param - useOffset, otherwise handle pagination on frontend
        if(useOffset == true){
            setPaginatedlist(formattedData);
        }else{
            const pageParam = parseInt(searchParams.get('page')) || 1;
            const currentPage = pageParam - 1;
            setPage(currentPage);
            const startIndex = currentPage * rowsPerPage;
            const endIndex = Math.min(startIndex + rowsPerPage, formattedData.length);
            const paginatedItems = formattedData.slice(startIndex,endIndex);
            setPaginatedlist(paginatedItems);
            setTotalCount(formattedData.length);
        }
        //if backend return total count then use it, but most apis dont return it.
        const returnedCount = allData?.totalCount;
        if(returnedCount)setTotalCount(returnedCount);
        
    }finally{
        setLoading(false);
    }
}

export default fetchTableData;